import PropTypes from 'prop-types';
import React, { Component } from "react";
import Relay from "react-relay"
import ArticleResult from "./ArticleResult"
import Masonry from "../elements/Masonry"
import LoadMoreLink from "../elements/LoadMoreLink"
import { getStyleTag, getStyles } from '../../styles/dynamicStyles';

class Results extends Component {

  static propTypes = {
    articleStyle: PropTypes.string.isRequired,
    hasNextPage: PropTypes.bool.isRequired,
    handleLoadMore: PropTypes.func.isRequired,
    loadMoreMessage: PropTypes.string,
    urlParams: PropTypes.object,
  }

  render() {
    const {
      hasNextPage,
      handleLoadMore,
      loadMoreMessage,
      articleStyle
    } = this.props

    const results = this.results()

    return (
      <section
        className="search-results__listings"
        data-article-style={articleStyle}
        style={getStyles(['search-results__listings', 'search-results__listings-search'])}
      >
        {getStyleTag(['search-results__listings', 'search-results__listings-search'])}
        {articleStyle === "fluid" ? (
          <Masonry
            ref={c => {
              if (c) this.masonry = c
            }}
          >
            {results}
          </Masonry>
        ) : (
          results
        )}
        {hasNextPage && (
          <LoadMoreLink onClick={handleLoadMore}>
            {loadMoreMessage ? loadMoreMessage : "Load More Items"}
          </LoadMoreLink>
        )}
      </section>
    )
  }

  results = () => {
    const uuid = this.props.urlParams ? this.props.urlParams.uuid : ""
    const resourcesProp = this.props.resources
    const resources = resourcesProp || []

    return resources.map(edge => (
      <ArticleResult
        cursor={edge.cursor}
        key={edge.node.id}
        resource={edge.node}
        itemUrl={uuid ? `/collections/${uuid}/${edge.node.id}` : ""}
      />
    ))
  }

  masonryLayout = () => {
    if (this.masonry) {
      this.masonry.masonryLayout()
    }
  }
}

export default Relay.createContainer(Results, {
  fragments: {
    resources: () => Relay.QL`
      fragment on ResourceEdge @relay(plural: true) {
        cursor
        node {
          id
          ${ArticleResult.getFragment("resource")}
        }
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/Results.js